import { createFileRoute } from "@tanstack/react-router";
import AmbetterMarketplaceInsurance, {
  config,
} from "@/pages/AmbetterMarketplaceInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/ambetter-marketplace-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ambetter Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Ambetter Marketplace insurance for TMS and SPRAVATO: prior auth, medical necessity, and coverage details for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Ambetter Marketplace TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Ambetter Marketplace insurance for TMS and SPRAVATO: prior auth, medical necessity, and coverage details for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ambetter-marketplace-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ambetter-marketplace-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AmbetterMarketplaceInsurance />;
}
